import moment from "moment";

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function ordinalSuffixOf(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}

export const dateAndTime = (isoDateString) => {
  let date = new Date(isoDateString);
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const formattedMinutes = String(minutes).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

  const formattedDate = `${day}-${month}-${year}, ${formattedHours}:${formattedMinutes}${ampm}`;
  return formattedDate;
};

export const formatDate = (date) => {
  if (!date) return "";

  const d = new Date(date);
  const day = ("0" + d.getDate()).slice(-2);
  const month = ("0" + (d.getMonth() + 1)).slice(-2);
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

export const dayMonthYear = (date) => {
  const d = new Date(date);
  const month = monthNames[d.getMonth()]?.slice(0, 3);
  const day = ordinalSuffixOf(d.getDate());
  const year = d.getFullYear();
  return day + " " + month + " " + year;
};

export const formatLocalAMPM = (inputDate) => {
  let date = new Date(inputDate);
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

export const combineDateAndTime = (date, time) => {
  // Creating moment date object  from timestamp  using moment
  const timeObject = moment(time);

  // Extract the time components
  const hours = timeObject.hours();
  const minutes = timeObject.minutes();
  const seconds = timeObject.seconds();

  // Create a new Moment.js object representing only the time part
  const finalTimeStampObject = moment(date)
    .hours(hours)
    .minutes(minutes)
    .seconds(seconds);

  // Get the Unix timestamp of the time object
  const timeTimestamp = moment(finalTimeStampObject).valueOf();
  return timeTimestamp;
};

export const day_numberMonth_wordsYear = (date) => {
  const d = new Date(date);
  const day = ("0" + d?.getDate())?.slice(-2);
  const month = monthNames[d?.getMonth()]?.slice(0, 3);
  const year = String(d?.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
};
